if (!customElements.get('hover-product-countdown')) {
  class HoverProductCountdown extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.end || '';
      this.endMs = this.parseParisDate(raw);

      if (Number.isNaN(this.endMs)) {
        this.endMs = 0;
      }

      this.refs = {
        d: this.querySelector('[data-cd-d]'),
        h: this.querySelector('[data-cd-h]'),
        m: this.querySelector('[data-cd-m]'),
        s: this.querySelector('[data-cd-s]'),
      };

      this.onTick = this.onTick.bind(this);
      this.onTick();
      this.timer = window.setInterval(this.onTick, 1000);
    }

    disconnectedCallback() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    parseParisDate(dateString) {
      if (!dateString) return 0;
      const [datePart, timePart = '00:00:00'] = dateString.split('T');
      if (!datePart) return 0;
      const [year, month, day] = datePart.split('-').map(Number);
      const [hour, minute, second] = timePart.split(':').map(Number);

      const utcDate = new Date(Date.UTC(
        year,
        month - 1,
        day,
        hour || 0,
        minute || 0,
        second || 0
      ));

      const parisFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Paris',
        timeZoneName: 'shortOffset',
      });

      const parts = parisFormatter.formatToParts(utcDate);

      const tzPart = parts.find(p => p.type === 'timeZoneName');

      let offsetHours = 1;

      if (tzPart?.value) {
        const match = tzPart.value.match(/GMT([+-]\d+)/);
        if (match) {
          offsetHours = parseInt(match[1], 10);
        }
      }

      return Date.UTC(
        year,
        month - 1,
        day,
        (hour || 0) - offsetHours,
        minute || 0,
        second || 0
      );
    }

    static pad2(n) {
      return String(Math.max(0, Math.floor(n))).padStart(2, '0');
    }

    onTick() {
      const now = Date.now();
      let ms = this.endMs - now;

      if (ms < 0) {
        ms = 0;
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }

      const totSec = Math.floor(ms / 1000);
      const d = Math.floor(totSec / 86400);
      const h = Math.floor((totSec % 86400) / 3600);
      const m = Math.floor((totSec % 3600) / 60);
      const s = totSec % 60;

      const dayStr = d < 100 ? HoverProductCountdown.pad2(d) : String(d);

      if (this.refs.d) {
        this.refs.d.textContent = dayStr;
      }

      if (this.refs.h) {
        this.refs.h.textContent = HoverProductCountdown.pad2(h);
      }

      if (this.refs.m) {
        this.refs.m.textContent = HoverProductCountdown.pad2(m);
      }

      if (this.refs.s) {
        this.refs.s.textContent = HoverProductCountdown.pad2(s);
      }
    }
  }

  customElements.define('hover-product-countdown', HoverProductCountdown);
}
